module.exports = __webpack_public_path__ + "static/media/checkBox.f569e173.svg";